export const enderecoFormat = (endereco) => {
  delete endereco.complemento;
  delete endereco.gia;
  delete endereco.ibge;
  delete endereco.unidade;
  endereco.estado = endereco.uf;
  delete endereco.uf;
  endereco.municipio = endereco.localidade;
  delete endereco.localidade;
  delete endereco.ddd;
  delete endereco.siafi;
  endereco.cep = endereco.cep.replace("-", "");
  switch (endereco.estado) {
    case "RO":
      endereco.estado = "Rondônia";
      break;
    case "AC":
      endereco.estado = "Acre";
      break;
    case "AM":
      endereco.estado = "Amazonas";
      break;
    case "RR":
      endereco.estado = "Roraima";
      break;
    case "PA":
      endereco.estado = "Pará";
      break;
    case "AP":
      endereco.estado = "Amapá";
      break;
    case "TO":
      endereco.estado = "Tocantins";
      break;
    case "MA":
      endereco.estado = "Maranhão";
      break;
    case "PI":
      endereco.estado = "Piauí";
      break;
    case "CE":
      endereco.estado = "Ceará";
      break;
    case "RN":
      endereco.estado = "Rio Grande do Norte";
      break;
    case "PB":
      endereco.estado = "Paraíba";
      break;
    case "PE":
      endereco.estado = "Pernambuco";
      break;
    case "AL":
      endereco.estado = "Alagoas";
      break;
    case "SE":
      endereco.estado = "Sergipe";
      break;
    case "BA":
      endereco.estado = "Bahia";
      break;
    case "MG":
      endereco.estado = "Minas Gerais";
      break;
    case "ES":
      endereco.estado = "Espírito Santo";
      break;
    case "RJ":
      endereco.estado = "Rio de Janeiro";
      break;
    case "SP":
      endereco.estado = "São Paulo";
      break;
    case "PR":
      endereco.estado = "Paraná";
      break;
    case "SC":
      endereco.estado = "Santa Catarina";
      break;
    case "RS":
      endereco.estado = "Rio Grande do Sul (*)";
      break;
    case "MS":
      endereco.estado = "Mato Grosso do Sul";
      break;
    case "MT":
      endereco.estado = "Mato Grosso";
      break;
    case "GO":
      endereco.estado = "Goiás";
      break;
    case "DF":
      endereco.estado = "Distrito Federal";
      break;
  }
  return endereco;
};

export const mascaraCpf = (cpf) => {
  return cpf
    ? cpf
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})/, "$1-$2")
        .replace(/(-\d{2})\d+?$/, "$1")
    : "";
};

export const formatDate = (data) => {
  console.log(data);
  const [ano, mes, dia] = data.split("-");
  return `${dia.substr(0, 2)}/${mes}/${ano}`;
};

export const validaEmail = (email) =>
  email.trim().match(/^[a-z0-9._-]+@[a-z0-9-]+\.[a-z]+(\.[a-z]+)?$/i);
